import style from './style.css';
import { route } from 'preact-router';
import { howToBuyRoute } from '../../../alias/homeRoutes';
import { tracker, UserActionType } from '../../../tracking';
import { generateUrlWithParams } from '../../../utils/routeHandler';

const MerchantCard = (props) => {
  const {
    campaignId,
    tile,
    index,
    pageKey,
    header,
    seeMore,
    howToBuyClick,
    lenderId,
    customStyle,
  } = props;

  const clickMerchant = ({
    pageKey,
    header,
    tile_name,
    handle,
    index,
    campaignId,
    lenderId,
  }) => {
    tracker.trackUserInteraction(
      UserActionType.CLICK,
      'bic_merchants_tile',
      pageKey,
      {
        tile_name,
        campaign_id: campaignId,
        lender_id: lenderId,
      },
    );
    return route(
      generateUrlWithParams(`${howToBuyRoute.internalRoute}${handle}`, {
        utm_campaign: campaignId,
      }),
    );
  };
  return (
    <div
      className={style.image}
      style={{
        backgroundImage: `url(${tile.mobileImgUrl})`,
        ...customStyle,
      }}
      onClick={() => {
        if (tile.bicStatus !== 'UPCOMING') {
          howToBuyClick();
          clickMerchant({
            campaignId,
            pageKey,
            header,
            tile_name: tile.name,
            handle: tile.handle,
            index,
            lenderId,
          });
        }
      }}
    />
  );
};

export default MerchantCard;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/merchantCard/index.js